import React, { useEffect, useState } from 'react'
import Header from "../template/Header";
import Menu from "../template/Menu";
import Footer from "../template/Footer";
import { Col, Row } from "react-bootstrap";
import Loading from "../components/loading/Loading";
import UploadIMG from "../components/uploads/UploadIMG";
import { useNavigate } from 'react-router-dom';
import { createAndUpdateContactUs, getContactUs } from "../api/admin_cms"
import {
    textSearchBtn,
    textResetBtn,
    textCreateBtn,
    colorSearchBtn,
    colorResetBtn,
    colorCreateBtn,
    iconSearchBtn,
    iconResetBtn,
    iconCreateBtn,
    hoverSearchBtn,
    hoverResetBtn,
    hoverCreateBtn,
    textSaveBtn,
    textCancleBtn,
    colorSaveBtn,
    colorCancleBtn,
    hoverSaveBtn,
    hoverCancleBtn,
    colorEditBtns,
    hoverEditBtns
} from "../components/ThemeConfig/btnConfig";
import { useButtonDynamicStyles } from "../components/useDynamic/Button_DynamicStyle";
import {
    alertValidateData,
    alertConfirmSave,
    alertSaved,
    alertCancel,
} from "../components/alertValid/AlertValid.js"
import CustomCKEditor from '../components/ckEditor/CustomCKEditor.js';

function ContactUs() {
    useButtonDynamicStyles(
        textSearchBtn,
        textResetBtn,
        textCreateBtn,
        colorSearchBtn,
        colorResetBtn,
        colorCreateBtn,
        iconSearchBtn,
        iconResetBtn,
        iconCreateBtn,
        hoverSearchBtn,
        hoverResetBtn,
        hoverCreateBtn,
        textSaveBtn,
        textCancleBtn,
        colorSaveBtn,
        colorCancleBtn,
        hoverSaveBtn,
        hoverCancleBtn,
        colorEditBtns,
        hoverEditBtns
    );

    const [isLoading, setLoading] = useState(false);

    const [editId, setEditId] = useState(null);
    const [txtEnDescValue, setTxtEnDescValue] = useState('');
    const [txtThDescValue, setTxtThDescValue] = useState('');

    const [images1, setImages1] = useState([]);
    const [imagesFromApi1, setImagesFromApi1] = useState([]);


    const [dataContact, setDataContact] = useState({
        tel: null,
        fax: null,
        mobile: null,
        email: null,
        lat: null,
        long: null,
        toOfficeBuilding: null,
        ccOfficeBuilding: null,
        toRetailCenter: null,
        ccRetailCenter: null,
        toCondoSale: null,
        ccCondoSale: null,
        toCondoRent: null,
        ccCondoRent: null,
        toASPCare: null,
        ccASPCare: null,
    });

    const formContactDatas = [
        {
            txtTitle: "Office For Rent",
            type1: "text",
            label1: "To",
            class1: dataContact.toOfficeBuilding === true ? "inp01 fontLight font-size03" : "inp01 fontLight font-size03",
            id1: "to_office_building",
            value1: dataContact.toOfficeBuilding,
            placeholder1: "Email Contact",
            onChange1: (event) => setDataContact({ ...dataContact, toOfficeBuilding: event.target.value }),
            disabled1: editId ? true : false,
            type2: "text",
            label2: "CC",
            class2: dataContact.ccOfficeBuilding === true ? "inp01 fontLight font-size03" : "inp01 fontLight font-size03",
            id2: "cc_office_building",
            value2: dataContact.ccOfficeBuilding,
            placeholder2: "Email Contact",
            onChange2: (event) => setDataContact({ ...dataContact, ccOfficeBuilding: event.target.value }),
            disabled2: editId ? true : false
        },
        {
            txtTitle: "Retail For Rent",
            type1: "text",
            label1: "To",
            class1: dataContact.toRetailCenter === true ? "inp01 fontLight font-size03" : "inp01 fontLight font-size03",
            id1: "to_retail_center",
            value1: dataContact.toRetailCenter,
            placeholder1: "Email Contact",
            onChange1: (event) => setDataContact({ ...dataContact, toRetailCenter: event.target.value }),
            disabled1: editId ? true : false,
            type2: "text",
            label2: "CC",
            class2: dataContact.ccRetailCenter === true ? "inp01 fontLight font-size03" : "inp01 fontLight font-size03",
            id2: "cc_retail_center",
            value2: dataContact.ccRetailCenter,
            placeholder2: "Email Contact",
            onChange2: (event) => setDataContact({ ...dataContact, ccRetailCenter: event.target.value }),
            disabled2: editId ? true : false
        },
        {
            txtTitle: "Condo For Sale",
            type1: "text",
            label1: "To",
            class1: dataContact.toCondoSale === true ? "inp01 fontLight font-size03" : "inp01 fontLight font-size03",
            id1: "to_condo",
            value1: dataContact.toCondoSale,
            placeholder1: "Email Contact",
            onChange1: (event) => setDataContact({ ...dataContact, toCondoSale: event.target.value }),
            disabled1: editId ? true : false,
            type2: "text",
            label2: "CC",
            class2: dataContact.ccCondoSale === true ? "inp01 fontLight font-size03" : "inp01 fontLight font-size03",
            id2: "cc_condo",
            value2: dataContact.ccCondoSale,
            placeholder2: "Email Contact",
            onChange2: (event) => setDataContact({ ...dataContact, ccCondoSale: event.target.value }),
            disabled2: editId ? true : false,
        },
        {
            txtTitle: "Condo For Rent",
            type1: "text",
            label1: "To",
            class1: dataContact.toCondoRent === true ? "inp01 fontLight font-size03" : "inp01 fontLight font-size03",
            id1: "to_conrad",
            value1: dataContact.toCondoRent,
            placeholder1: "Email Contact",
            onChange1: (event) => setDataContact({ ...dataContact, toCondoRent: event.target.value }),
            disabled1: editId ? true : false,
            type2: "text",
            label2: "CC",
            class2: dataContact.ccCondoRent === true ? "inp01 fontLight font-size03" : "inp01 fontLight font-size03",
            id2: "cc_conrad",
            value2: dataContact.ccCondoRent,
            placeholder2: "Email Contact",
            onChange2: (event) => setDataContact({ ...dataContact, ccCondoRent: event.target.value }),
            disabled2: editId ? true : false,
        },
        {
            txtTitle: "ASP Customer Care",
            type1: "text",
            label1: "To",
            class1: dataContact.toASPCare === true ? "inp01 fontLight font-size03" : "inp01 fontLight font-size03",
            id1: "to_contact",
            value1: dataContact.toASPCare,
            placeholder1: "Email Contact",
            onChange1: (event) => setDataContact({ ...dataContact, toASPCare: event.target.value }),
            disabled1: editId ? true : false,
            type2: "text",
            label2: "CC",
            class2: dataContact.ccASPCare === true ? "inp01 fontLight font-size03" : "inp01 fontLight font-size03",
            id2: "cc_contact",
            value2: dataContact.ccASPCare,
            placeholder2: "Email Contact",
            onChange2: (event) => setDataContact({ ...dataContact, ccASPCare: event.target.value }),
            disabled2: editId ? true : false
        },
    ];

    const handleSelectedImages1 = (images) => {
        setImages1(images);
    };
    const handleSelectedRemoveImg1 = (data) => {
        // setDataStClear(data);
        setImages1(data);
    };

    const navigate = useNavigate();
    const navigateToBack = (page) => {
        navigate(page);
    };

    const validateEmail = (email) => {
        // Regular expression for email validation
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailRegex.test(email);
    };

    const alertValidate = async () => {
        const result = await alertValidateData();
            if (result.isConfirmed) {
                return;
            } else {
                return;
            }
    }
    
    const handleSaveBtn = async () => {
        try {
            const emailFields = [
                { field: 'email_office', value: dataContact.toOfficeBuilding },
                { field: 'email_retail', value: dataContact.toRetailCenter },
                { field: 'email_condo_sale', value: dataContact.toCondoSale },
                { field: 'email_condo_rent', value: dataContact.toCondoRent },
                { field: 'email_cs_care', value: dataContact.toASPCare },
                { field: 'email', value: dataContact.email }
            ];

            const ccEmailFields = [
                { field: 'cc_email_office', value: dataContact.ccOfficeBuilding },
                { field: 'cc_email_retail', value: dataContact.ccRetailCenter },
                { field: 'cc_email_condo_sale', value: dataContact.ccCondoSale },
                { field: 'cc_email_condo_rent', value: dataContact.ccCondoRent },
                { field: 'cc_email_cs_care', value: dataContact.ccASPCare },

            ];
    
    
            // Validate required email fields
            const invalidEmailFields = emailFields.filter(emfield => emfield.value == '' && emfield.value == null && emfield.value == undefined || !validateEmail(emfield.value));
            const invalidEmailCCFields = ccEmailFields.filter(ccfield => ccfield.value != '' && ccfield.value != null && ccfield.value != undefined ).filter(ccfield2 => !validateEmail(ccfield2.value));
            if (invalidEmailFields.length === 0 && invalidEmailCCFields.length === 0) {
                const formatedBodyToServer = {
                    address_en: txtEnDescValue,
                    address_th: txtThDescValue,
                    tel: dataContact.tel,
                    fax: dataContact.fax,
                    mobile: dataContact.mobile,
                    lat: dataContact.lat,
                    long: dataContact.long,
                    map_img: images1 ?? null,
                    ...Object.fromEntries(emailFields.map(field => [field.field, field.value])),
                    ...Object.fromEntries(ccEmailFields.map(field => [field.field, field.value])),
                };
    
                if (!formatedBodyToServer.address_en || !formatedBodyToServer.address_th) {
                    await alertValidate();
                } else {
                    const result = await alertConfirmSave();
                        if (result.isConfirmed) {
                            await setLoading(true);
                            const response = await createAndUpdateContactUs(formatedBodyToServer);
                            setLoading(false);
                            if (response.status === "success") {
                                const result = await alertSaved();
                                    if (result.isConfirmed) {
                                        window.location.reload();
                                    }
                            }
                        }
                }
            } else {
                alertValidate();
            }
        } catch (error) {
            console.log('found error ', error);
        }
    };

    const handleClickCancel = async () => {
        const res = await alertCancel();
                if (res.isConfirmed) {
                    navigateToBack("/infoContactUs");
                }
                else { }
    };

    async function urlToBlob(url) {
        // Fetch the image data from the URL
        const response = await fetch(url);
    
        // Convert the fetched image data to Blob
        const blob = await response.blob();
    
        return blob;
    }

    const fetchingData = async () => {
        try {
            await setLoading(true);
            const response = await getContactUs()

            await setDataContact({
                ...dataContact,
                tel: response?.data?.tel,
                fax: response?.data?.fax,
                mobile: response?.data?.mobile,
                email: response?.data?.email,
                lat: response?.data?.lat,
                long: response?.data?.long,
                toOfficeBuilding: response?.data?.email_office,
                ccOfficeBuilding: response?.data?.cc_email_office,
                toRetailCenter: response?.data?.email_retail,
                ccRetailCenter: response?.data?.cc_email_retail,
                toCondoSale: response?.data?.email_condo_sale,
                ccCondoSale: response?.data?.cc_email_condo_sale,
                toCondoRent: response?.data?.email_condo_rent,
                ccCondoRent: response?.data?.cc_email_condo_rent,
                toASPCare: response?.data?.email_cs_care,
                ccASPCare: response?.data?.cc_email_cs_care,
            })

            if (response?.data?.address_en) {
                setTxtEnDescValue(response?.data?.address_en)
            }
            if (response?.data?.address_th) {
                setTxtThDescValue(response?.data?.address_th)
            }
            setImagesFromApi1([{
                id: 0,
                status: false,
                src:
                    response?.data?.map_img === null ||
                    response?.data?.map_img === ""
                    ? ''
                    : response?.data?.map_img,
                file: response?.data?.map_img ? await urlToBlob(response?.data?.map_img) : null,
                size: 1024*1024*4, //hard code ให้ผ่าน validate 
                type:'image/jpg' //hard code ให้ผ่าน validate
            }])
        } catch (error) {
            console.log('error', error);
        }
        await setLoading(false);
    }

    useEffect(() => {
        fetchingData()
    }, [])
    return (
        <>
            {isLoading ? <Loading /> : ""}
            <style>
                {`
                    .ck.ck-editor__main>.ck-editor__editable:not(.ck-focused) {
                        height: 200px;
                    }
                `}
            </style>
            <Header parentmenu={"CONTACT US"} />
            <Menu
                parentmenu={"infoContactUs"}
                activemenu={"infoContactUs"}
            />
            <div className="content-wrapper">
                <div className="container-fluid pdb-page">
                    <div className="box-white">
                        <Row>
                            <Col xs={12}>
                                <font className="font-size07 colorBlack01 fontBold d-flex align-items-center">
                                    <img src="assets/icons/ic-contact.png" className="ic-user01 me-2" alt="" />
                                    CONTACT US
                                </font>
                            </Col>
                        </Row>
                        <div className='mx-5 mt-4'>
                            <Row>
                                <Col xs={12}>
                                    <font className="font-size01 colorBlack01 fontBold">
                                        All Seasons Property Co., Ltd.
                                    </font>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={6}>
                                    <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                        English
                                    </font>
                                    <span className=' colorRed'>*</span>
                                </Col>
                                <Col xs={6}>
                                    <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                        ภาษาไทย
                                    </font>
                                    <span className=' colorRed'>*</span> 
                                </Col>
                            </Row>
                            <Row className='mt-2'>
                                <Col xs={6}>
                                    <CustomCKEditor
                                        data={txtEnDescValue}
                                        onChange={(newData) => {
                                            setTxtEnDescValue(newData);
                                        }}
                                        placeholder="Address"
                                    />
                                </Col>
                                <Col xs={6}>
                                    <CustomCKEditor
                                        data={txtThDescValue}
                                        onChange={(newData) => {
                                            setTxtThDescValue(newData);
                                        }}
                                        placeholder="ที่อยู่"
                                    />
                                </Col>
                            </Row>
                            <Row className='mt-4'>
                                <Col xs={6}>
                                    <Row className='align-items-center'>
                                        <Col xs={2}><span className='fontReg font-size03 colorBlack01'>Tel</span></Col>
                                        <Col xs={9} className='pe-1'>
                                            <input
                                                type="text"
                                                className="inp01 fontLight font-size03"
                                                id="tel"
                                                placeholder="Tel"
                                                value={dataContact.tel}
                                                onChange={(event) =>
                                                    setDataContact({
                                                        ...dataContact,
                                                        tel: event.target.value,
                                                    })
                                                }
                                                disabled={editId ? true : false}
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={6}>
                                    <Row className='align-items-center'>
                                        <Col xs={2}><span className='fontReg font-size03 colorBlack01'>Fax</span></Col>
                                        <Col xs={9} className='pe-1'>
                                            <input
                                                type="text"
                                                className="inp01 fontLight font-size03"
                                                id="fax"
                                                placeholder="Fax"
                                                value={dataContact.fax}
                                                onChange={(event) =>
                                                    setDataContact({
                                                        ...dataContact,
                                                        fax: event.target.value,
                                                    })
                                                }
                                                disabled={editId ? true : false}
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row className='mt-4'>
                                <Col xs={6}>
                                    <Row className='align-items-center'>
                                        <Col xs={2}><span className='fontReg font-size03 colorBlack01'>Mobile</span></Col>
                                        <Col xs={9} className='pe-1'>
                                            <input
                                                type="text"
                                                className="inp01 fontLight font-size03"
                                                id="mobile"
                                                placeholder="Mobile"
                                                value={dataContact.mobile}
                                                onChange={(event) =>
                                                    setDataContact({
                                                        ...dataContact,
                                                        mobile: event.target.value,
                                                    })
                                                }
                                                disabled={editId ? true : false}
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={6}>
                                    <Row className='align-items-center'>
                                        <Col xs={2}><span className='fontReg font-size03 colorBlack01'>Email </span><span className=' colorRed'>*</span></Col>
                                        <Col xs={9} className='pe-1'>
                                            <input
                                                type="text"
                                                className="inp01 fontLight font-size03"
                                                id="email"
                                                placeholder="Email"
                                                value={dataContact.email}
                                                onChange={(event) =>
                                                    setDataContact({
                                                        ...dataContact,
                                                        email: event.target.value,
                                                    })
                                                }
                                                disabled={editId ? true : false}
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row className='mt-4'>
                                <Col xs={6}>
                                    <Row className='align-items-center'>
                                        <Col xs={2}><span className='fontReg font-size03 colorBlack01'>Map</span></Col>
                                        <Col xs={9} className='pe-1'>
                                            <UploadIMG
                                                limit={1}
                                                onSelectedImages={handleSelectedImages1}
                                                images={imagesFromApi1}
                                                txtDetail={"jpg. / 1920x800 px , limit size 5MB"}
                                                removeImg={handleSelectedRemoveImg1}
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={6}>
                                    <Row className='align-items-center'>
                                        <Col xs={2} className='pe-0'><span className='fontReg font-size03 colorBlack01'>Google Map</span></Col>
                                        <Col xs={4} className='pe-1'>
                                            <input
                                                type="text"
                                                className="inp01 fontLight font-size03"
                                                id="lat"
                                                placeholder="Lat"
                                                value={dataContact.lat}
                                                onChange={(event) =>
                                                    setDataContact({
                                                        ...dataContact,
                                                        lat: event.target.value,
                                                    })
                                                }
                                                disabled={editId ? true : false}
                                            />
                                        </Col>
                                        <Col xs={4} className='pe-1'>
                                            <input
                                                type="text"
                                                className="inp01 fontLight font-size03"
                                                id="long"
                                                placeholder="Long"
                                                value={dataContact.long}
                                                onChange={(event) =>
                                                    setDataContact({
                                                        ...dataContact,
                                                        long: event.target.value,
                                                    })
                                                }
                                                disabled={editId ? true : false}
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                    </div>
                    <div className="box-white mt-4">
                        <div className='mx-5'>
                            <Row>
                                <Col xs={12}>
                                    <font className="font-size01 colorBlack01 fontBold">
                                        Email Contact
                                    </font>
                                </Col>
                            </Row>
                            {formContactDatas.map((data, index) => (
                                <div className='mt-2' key={index}>
                                    <Row>
                                        <Col xs={12} >
                                            <font className="font-size01 colorBlack01 fontBold">
                                                {data.txtTitle} 
                                            </font>
                                        </Col>
                                    </Row>
                                    <Row className='mt-2'>
                                        <Col xs={6}>
                                            <Row className='align-items-center'>
                                                <Col xs={1}><span className='fontReg font-size03 colorBlack01'>{data.label1}</span> <span className=' colorRed'>*</span></Col>
                                                <Col xs={10} className='pe-1'>
                                                    <input
                                                        type={data.type1}
                                                        className={data.class1}
                                                        id={data.id1}
                                                        placeholder={data.placeholder1}
                                                        value={data.value1}
                                                        onChange={data.onChange1}
                                                        disabled={data.disabled1}
                                                    />
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col xs={6}>
                                            <Row className='align-items-center'>
                                                <Col xs={1}><span className='fontReg font-size03 colorBlack01'>{data.label2}</span></Col>
                                                <Col xs={10} className='pe-1'>
                                                    <input
                                                        type={data.type2}
                                                        className={data.class2}
                                                        id={data.id2}
                                                        placeholder={data.placeholder2}
                                                        value={data.value2}
                                                        onChange={data.onChange2}
                                                        disabled={data.disabled2}
                                                    />
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </div>
                            ))}
                        </div>
                    </div>
                    <Row className="ms-5 mt-4">
                        <Col xs={1} className="p-0 d-flex justify-content-start me-4">
                            <button
                                className="btn-cancle01"
                                onClick={() => handleClickCancel()}
                            >
                                CANCEL
                            </button>
                        </Col>
                        <Col xs={1} className="p-0 d-flex justify-content-start">
                            <button
                                className="btn-save01"
                                onClick={(e) => {
                                    handleSaveBtn();
                                }}
                            >
                                SAVE
                            </button>
                        </Col>
                    </Row>
                </div>
            </div>
            <Footer />
        </>

    )
}

export default ContactUs;